import React from 'react';

const Cover = ({ children }) => {
  return <div className=" w-screen">{children}</div>;
};

export default Cover;
